<template>
  <div class="websitePopup">
    <el-dialog
      title="站内信"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose"
    >

      <div>
        <div v-if="dataList.length != 0" class="mesContent">
          <div v-for="(item, index) in dataList" :key="index" class="mc_item">
            <div>{{ item.content }}</div>
            <div>{{ item.createTime | dateFormate }}</div>
          </div>
        </div>
        <!-- 暂无数据 -->
        <div v-else class="noData">暂无数据</div>
        <el-pagination
          v-if="dataList.length != 0"
          popper-class="_popStyle"
          :current-page="pageData.currentPage"
          :page-sizes="pageData.pageSizes"
          :page-size="pageData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageData.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </el-dialog>
    <el-dialog
      :title="atItem.title"
      :visible.sync="dialogVisible1"
      width="30%"
      :before-close="handleClose1"
    >
      <span>{{ atItem.content }}</span>
    </el-dialog>
  </div>
</template>

<script>
/*global http protocol*/
export default {
  data() {
    return {
      dialogVisible1: false,
      dialogVisible: false,
      pageData: {
        total: null,
        pageSizes: [10, 20, 30, 40],
        pageSize: 20,
        currentPage: 1
      },
      dataList: [],
      atItem: {
        content: '',
        title: ''
      }
    }
  },
  methods: {
    goDetail(item) {
      this.atItem = item
      this.dialogVisible1 = true
    },
    dialogShow() {
      this.dialogVisible = true
      this.getData()
    },
    handleClose1() {
      this.dialogVisible1 = false
    },
    handleClose() {
      this.dialogVisible = false
    },
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.getData()
    },
    getData() {
      protocol.param_getWebsiteMessage.param.startTime = 0
      protocol.param_getWebsiteMessage.param.page = this.pageData.currentPage - 1
      protocol.param_getWebsiteMessage.param.size = this.pageData.pageSize
      http.postFront(protocol.param_getWebsiteMessage).then(response => {
        var { code, value } = response.data
        if (Number(code) === 0) {
          this.dataList = value.content
          this.pageData.total = value.totalElements
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.websitePopup {
    padding: 2vw;
}
.mesContent {
    .mc_item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 1vw;
        // border-bottom: 1px solid #ccc;
        cursor: pointer;
    }
}
.noData {
  height: 50px;
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
